const MathUtilities = {
  linear_map(value, inMin, inMax, outMin, outMax) {
    return outMin + ((value - inMin) / (inMax - inMin)) * (outMax - outMin);
  },
};

export { MathUtilities };
